import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'

const SendNowModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.sendNowModalVisible}
        onClose={distributeStore.hideSendNowModal}
    >
        <div className="delete-modal-content">
            <h2>{i18n.t('distributionSendNowModal.title')}</h2>

            <p>{i18n.t('distributionSendNowModal.subtitle')}</p>
        </div>

        <ModalFooter>
            <div className="delete-modal-footer-content">
                <Button cssClass="regular error" onClick={distributeStore.hideSendNowModal}>
                    {i18n.t('distributionSendNowModal.no')}
                </Button>

                <Button cssClass="regular primary" onClick={distributeStore.sendNow}>
                    {i18n.t('distributionSendNowModal.yes')}
                </Button>
            </div>
        </ModalFooter>
    </Modal>
)

export default observer(SendNowModal)
